/**
 * Folding a ticket into the list, however it arrived.
 *
 * The same ticket genuinely arrives twice. The server broadcasts
 * `ticket:updated` into the app room *before* it answers the request that
 * caused it, and the agent who filed it is in that room — with a database
 * write and, for an assigned ticket, a push and an email sitting between the
 * broadcast and the response, the socket copy reliably wins the race.
 *
 * So every path into the list goes through here: the create response, the
 * patch response, and the socket event. Prepending the created ticket without
 * this check is what produced two rows for one ticket.
 *
 * @param {object[]} list
 * @param {object} ticket
 * @returns {object[]} a new list, newest activity first
 */
export function upsertTicket(list, ticket) {
  const without = list.filter((t) => t.id !== ticket.id);
  return [ticket, ...without].sort(
    (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
  );
}

export default { upsertTicket };
